export const getAnyOfValue = (id, list) => {
  // anyOf形式（レガシー）
  const { anyOf } = list
  if(anyOf) {
    const filtered = anyOf.filter(obj => {
      return obj.enum.includes(id)
    })
    if(filtered.length > 0) {
      const { title } = filtered[0]
      return title
    }
  }

  // enum + enumNames形式（新形式）
  const { enum: enumValues, enumNames } = list
  if(enumValues && enumNames) {
    const index = enumValues.indexOf(id)
    if(index !== -1) {
      return enumNames[index]
    }
  }

  return null
}
